import { useCallback, useState } from 'react';
const useToggle = ({ isDefaultOpen }) => {
    const [isOpen, setIsOpen] = useState(isDefaultOpen ?? false);
    const open = useCallback(() => {
        setIsOpen(true);
    }, []);
    const toggle = useCallback(() => {
        setIsOpen((value) => !value);
    }, []);
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);
    return { isOpen, open, close, toggle };
};
export { useToggle };
//# sourceMappingURL=useToggle.js.map